import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: 1;
  justify-content: center;
  align-items: center;
`;
export const Content = styled.div`
  width: 95%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  background-color: rgba(0, 0, 0, 0.8);
  position: relative;
  border-radius: 15px;

  div {
    width: 100%;
    height: 100%;
  }

  div img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* OU cover, dependendo do efeito desejado */
    max-width: 100%;
    border-radius: 10px;
    display: block;
  }

  button {
    padding: 10px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    background-color: #28a137;
    color: white;
    margin: 10px;
  }
`;

export const IconClose = styled.img`
  position: absolute;
  top: 0px;
  right: 0px;
  margin: 10px;
  cursor: pointer;
`;
